import router from "../../router";
import dealer_routes from "../../routes";
import dealer_nav from "../../nav";
import {accountAllowedRoute, accountFilteredMenu} from "../../../js/services/navFilter";
import axios from "axios";
import mainOidc from "../../../dealer_area/auth";
import i18n from "../../../js/services/locale";
import store from "../index";

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || '',
        status: null,
        settings: {},
        user: {},
        group: null,
        language: null,
        oidc: {
            role: []
        },
    },
    mutations: {
        logout(state) {
            state.status = null;
            state.token = null;
        },
        auth_success(state, user){
            state.status = 'success';
            state.token = user.token;
            state.user = user;
        },
        auth_request(state) {
            state.status = 'loading';
        },
        auth_error(state) {
            state.status = 'error';
        },
        profile(state, user) {
          state.user.name = user.name;
          state.user.surname = user.surname;
        },
        settings(state, settings) {
          state.user.customer.settings = settings;
        },
        timezone(state, timezone) {
          state.user.timezone = timezone;
        },
        set_group(state, data) {
          state.group = data;
        },
        set_language(state, data) {
            state.language = data;
        },
        set_oidc(state, data) {
            state.oidc = data;
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        user: state => state.user,
        group: state => state.group,
        dealer: state => state.user.dealer,
        language: state => state.user.language,
        timezone: state => state.user.timezone,
        oidc: state => state.oidc,
    },
    actions: {
        logout({commit}){
            return new Promise(async (resolve, reject) => {
                commit('logout');
                localStorage.removeItem('customer_token');
                delete axios.defaults.headers.common['Authorization'];
                await mainOidc.signOut()
                resolve();
            })
        },
        login({commit, dispatch}, user){
            let self = this;
            return new Promise((resolve, reject) => {
                commit('auth_request');

                // Set default TOKEN header
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + mainOidc.accessToken;

                const includes = 'dealer,language,timezone';
                const url = laravel.config.app_url + '/dealer/api/v3/profile?include=' + includes;

                axios.get(url, { errorHandle: false })
                    .then(({data}) => {
                        user = {...user, ...data.data};

                        if (localStorage.getItem('language') !== user.language.code) {
                            window.location = window.location = `/${user.language.code}/dealer/dashboard`;
                        }
                        commit('set_oidc', mainOidc.userProfile);
                        commit('set_group', 'dealer');
                        commit('auth_success', {
                            ...user,
                            group: 'dealer',
                            api_path: '/dealer/api',
                            token: mainOidc.accessToken,
                        });

                        // set acl roles data
                        let roles = accountGetDealerRoles(user);

                        let home= user?.dealer?.market?.code === 'mkt_it'? 'Dashboard' : 'Customers';

                        router.addRoutes(dealer_routes(user.language.code, home));

                        // acls on routes
                        router.beforeEach((to, from, next) => {

                            let allowed = accountAllowedRoute(to, roles);
                            // if allowed continue to the next route otherwise redirect to home
                            if (allowed)
                                next();
                            else {
                                if (to.name == 'Account demo') {
                                    router.push({
                                        name: 'AddDemoCustomer'
                                    });
                                } else if (to.name == 'AddDemoCustomer') {
                                    router.push({
                                        name: 'Account demo'
                                    });
                                } else if (roles.includes('gcs_unchecked')) {
                                    router.push({
                                        name: 'Gcs'
                                    });
                                } else {
                                    router.push({
                                        name: 'Home'
                                    });
                                }
                            }
                        })

                        self.commit('setAcls', roles);
                        self.commit('setMenu', accountFilteredMenu(dealer_nav.items, roles));
                        self.commit('setSideMenu', accountFilteredMenu(dealer_nav.side_items, roles));
                        resolve(user);
                    }).catch(err => {
                    dispatch('logout');
                    localStorage.removeItem('token');
                    reject(err);
                });
            })
        },
        updateProfile({commit}, user) {
            commit('profile', user);
        },
        updateSettings({commit}, settings) {
            commit('settings', settings);
        },
        updateTimezone({commit}, timezone){
            commit('timezone', timezone);
        },
        updateLanguage({commit}, language_code){
            commit('set_language', {
                code: language_code,
            });

            i18n.locale = language_code;
            axios.get('/lang/' + language_code + '.json')
                .then((response) => {
                    i18n.mergeLocaleMessage(language_code, response.data || {});
                })
        },
    },

};

export function accountGetDealerRoles(user) {
    let roles = [];

    if(!user.dealer) {
      return roles;
    }

    // if is a known dealer
    if (user.dealer.is_unknown)
        roles.push('unknown');
    // check for distributor role
    if (user.dealer.is_distributor)
        roles.push('distributor');
    // check if is under a distributor
    if (user.dealer.has_distributor)
        roles.push('has_distributor');
    // check for markets rules
    if (user.dealer.market)
        roles.push(user.dealer.market.code);
    // if is a abroad dealer with benefits
    if (user.dealer.is_abroad_allowed)
        roles.push('abroad');

    //gcs checks
    roles.push( (user.dealer?.gcs_status?.confirmed) ? 'gcs_confirmed' : 'gcs_unconfirmed');
    roles.push( (user.dealer?.gcs_status?.confirmed) ? 'gcs_checked' : 'gcs_unchecked');

    roles.push( (user.dealer.has_demo) ? 'has_demo' : 'not_has_demo');
    roles.push( (user.dealer.prepayment || user.dealer.has_made_prepayment) ? 'prepayment' : 'no_prepayment');
    roles.push( (user.dealer.active && user.active_dealer && !user.dealer.x3_amm_lock) ? 'active_account' : 'no_active_account')
    roles.push( (user.dealer.x3_amm_lock) ? 'amm_lock' : 'no_amm_lock')
    roles.push( (user.dealer.x3_com_lock) ? 'com_lock' : 'no_com_lock')

    return roles;
}
